import { gql } from 'apollo-boost';

const EXCHANGE_SHARECODE_MUTATION = gql`
  mutation ExchangeShareCode($shareCode: String!) {
    exchangeShareCode(shareCode: $shareCode) {
      token
      expiry
    }
  }
`;

const LIST_HISTORY_QUERY = gql`
  query ListHistory($session: String!, $limit: Int, $token: String) {
    listHistory(session: $session, limit: $limit, token: $token) {
      events {
        type
        recordedAt
        recording {
          wheezeRate
          triggers {
            type
            value
          }
          symptoms {
            type
            value
          }
          recordingFile {
            url
          }
        }
        medicationUse {
          dose
          dosageType
          medication {
            id
            name
            category
          }
        }
        selfAssessment {
          breathingDifficulty
          triggers {
            type
            value
          }
          symptoms {
            type
            value
          }
          notes
        }
      }
      nextToken
    }
  }
`;

export { LIST_HISTORY_QUERY, EXCHANGE_SHARECODE_MUTATION };
